import TailwindScrollbar from 'tailwind-scrollbar'
import PrimeUI from 'tailwindcss-primeui'

/* Helper: wraps a CSS variable in color-mix() so Tailwind's /opacity modifier works */
const cm = (v: string) => `color-mix(in srgb, var(${v}) calc(100% * <alpha-value>), transparent)`

/* Generate a full shade scale (50–950 + DEFAULT at 500) for a severity/accent palette */
function severityScale(prefix: string) {
  const shades = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950] as const
  const scale: Record<string, string> = {}
  for (const s of shades) scale[s] = cm(`--p-${prefix}-${s}`)
  scale.DEFAULT = cm(`--p-${prefix}-500`)
  return scale
}

export default {
  /*
   * Three-state dark mode — keep in sync with theme-config.css.
   * `dark:` applies when: (OS dark AND not at/under .w-theme-light) OR (at/under .w-theme-dark).
   * Requires Tailwind >= 3.4.1 (variant strategy with multiple selectors).
   */
  darkMode: ['variant', [
    '@media (prefers-color-scheme: dark) { &:not(.w-theme-light *):not(.w-theme-light) }',
    '&:is(.w-theme-dark, .w-theme-dark *)',
  ]] as ['variant', string[]],
  theme: {
    extend: {
      colors: {
        secondary: severityScale('secondary'),
        danger: severityScale('danger'),
        success: severityScale('success'),
        warn: severityScale('warn'),
        info: severityScale('info'),
        help: severityScale('help'),
        accent: severityScale('accent'),
        surface: {
          850: cm('--p-surface-850'),
        },
      },
    },
  },
  plugins: [
    PrimeUI,
    TailwindScrollbar({ nocompatible: true, preferredStrategy: 'pseudoelements' }),
  ],
}
